import { render } from "./PrintDocumentModal.vue?vue&type=template&id=542afdf9"
import script from "./PrintDocumentModal.vue?vue&type=script&lang=js"
export * from "./PrintDocumentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__